import { render, staticRenderFns } from "./BarcodeField.vue?vue&type=template&id=08fac39f&scoped=true"
import script from "./BarcodeField.vue?vue&type=script&lang=js"
export * from "./BarcodeField.vue?vue&type=script&lang=js"
import style0 from "./BarcodeField.vue?vue&type=style&index=0&id=08fac39f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fac39f",
  null
  
)

export default component.exports